import React, { memo } from 'react';
import {
  View,
  Image,
  FlatList,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { IconCheckMark } from '@redlink/components/atoms';
import { isMobile } from 'react-device-detect';

export const SelectableProjects = memo(
  ({ data, onSelect, selectedProjects }) => {
    return (
      <FlatList
        keyExtractor={({ id }) => `${id}`}
        {...{ data }}
        numColumns={3}
        extraData={selectedProjects}
        renderItem={({ item }) => (
          <SelectableItem
            {...{ item }}
            onPress={() => onSelect(item)}
            isSelected={selectedProjects.indexOf(item.id) === -1 ? false : true}
          />
        )}
        showsVerticalScrollIndicator={false}
      />
    );
  }
);

export const SelectableItem = memo(
  ({ item: { images = [] }, isSelected, onPress }) => {
    const { styles } = useStyle();
    return (
      <TouchableOpacity
        activeOpacity={0.7}
        {...{ onPress }}
        style={isMobile ? styles.itemContainerMobile : styles.itemContainer}
      >
        {isSelected && <Wrapper />}
        <Image
          style={isMobile ? styles.imageMobile : styles.image}
          source={{ uri: images[0]?.thumbnailUrl }}
        />
      </TouchableOpacity>
    );
  }
);

const Wrapper = memo(() => {
  const { styles } = useStyle();
  return (
    <View style={[styles.itemWrapper, isMobile && styles.itemWrapperMobile]}>
      <IconCheckMark />
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  itemContainer: {
    width: 128,
    height: 128,
  },
  itemContainerMobile: {
    width: 114,
    height: 114,
  },
  itemWrapper: {
    ...StyleSheet.absoluteFillObject,
    width: 126,
    height: 126,
    zIndex: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.green11,
  },
  itemWrapperMobile: {
    width: 112,
    height: 112,
  },
  image: {
    width: 124,
    height: 124,
  },
  imageMobile: {
    width: 110,
    height: 110,
  },
}));
